import { useNavigate } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import { haveValue } from "../../../helper/common";

const GuarantorPills = (props) => {
  const { guarantor_detail } = props;
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const handleNavigateEdit = () => {
    if (guarantor_detail?.status == "pending") {
      navigate(`/guarantor/setup?guarantor_id=${guarantor_detail?._id}`);
    } else if (
      guarantor_detail?.status == "processing" ||
      guarantor_detail?.status == "accepted"
    ) {
      navigate(`/guarantor/details/${guarantor_detail?._id}`);
    } else {
      console.log("Do nothing");
    }
  };

  return (
    <>
      <div
        className="d-flex cursor-pointer guarantorCard gap-3"
        onClick={handleNavigateEdit}
      >
        <img src="/images/profile-icon-light.svg" alt="" />
        <div>
          <p>{guarantor_detail?.gurantor_name}</p>
          <span>
            {haveValue(guarantor_detail?.gurantor_relation)
              ? _t((guarantor_detail?.gurantor_relation).toLowerCase())
              : ""}
          </span>
        </div>
        <img src="/images/rightAngleArrow.svg" alt="Arrow" className="ms-2" />
      </div>
    </>
  );
};

export default GuarantorPills;
